<template lang="pug">
  section#sidebar
    nav#sb-main-menu(v-if="mainItems && mainItems.length")
      TreeMenu(:items="mainItems" :max-depth="2" v-if="! error && loaded" toggle-event="click")
    hr(v-if="headerItems && headerItems.length")
    nav#sb-header-menu(v-if="headerItems && headerItems.length")
      TreeMenu(:items="headerItems" :max-depth="1" v-if="! error && loaded" toggle-event="click")
    hr(v-if="footerItems && footerItems.length")
    nav#sb-header-menu(v-if="footerItems && footerItems.length")
      TreeMenu(:items="footerItems" :max-depth="1" v-if="! error && loaded" toggle-event="click")
</template>

<script>
import { get, cloneDeep, trim } from '@/helpers';
import { mapGetters } from 'vuex';

import NestedSet from '@/nested-set-lib';

export default {
    name: 'Sidebar',
    computed: {
        mainItems() {
            const menu = this.menus.find(menu => menu.key === 'main-menu');
            let items = get(menu, 'menuItems') || [];
            items = cloneDeep(items);

            if (items.length) {
                return NestedSet.createTree(items);
            }

            return items;
        },
        headerItems() {
            const menu = this.menus.find(menu => menu.key === 'header-menu');
            let items = get(menu, 'menuItems') || [];
            items = cloneDeep(items);

            if (items.length) {
                return NestedSet.createTree(items);
            }

            return items;
        },
        footerItems() {
            const menu = this.menus.find(menu => menu.key === 'footer-menu');
            let items = get(menu, 'menuItems') || [];
            items = cloneDeep(items);

            if (items.length) {
                return NestedSet.createTree(items);
            }

            return items;
        },
        image() {
            let storageRoute = `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`;
            storageRoute = trim(storageRoute, '/');

            const fit = 'fit=fill&w=350&h=150';

            let width = this.logo.width;
            let height = this.logo.height;

            return {
                src: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}`,
                error: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=blur`,
                width,
                height
            };
        },
        ...mapGetters({
            logo: 'logo',
            menus: 'menus',
            loaded: 'loaded',
            error: 'error'
        })
    },
    mounted() {
        this.$emit('mounted');
    }
};
</script>

<style lang="sass" scoped>
section#sidebar
  background-color: #1D1F20
  background-image: linear-gradient(145deg, #1D1F20, #404348)

  // #sb-main-menu
  //   padding-top: 56px

  // .logo-wrapper + #sb-main-menu
  //   padding-top: 0
  //
  // .logo-wrapper
  //   margin-bottom: 20px
  //   background: white
  //   padding: 20px
  //   height: 140px
  //   & > img
  //     max-height: 100%
  //     width: auto
  //
  // hr
  //   background-color: rgba(255, 255, 255, 0.05)
  //   height: 1px

  nav
    ul.tree-menu::v-deep
      li
        // &.visible
        & > ul
          &.tree-menu
            border-left: 3px solid rgba(255, 255, 255, .1)
            margin-left: 22px
        a
          padding: 10px 20px
          display: block
          color: #ffffff
          &:hover
            background-color: rgba(255, 255, 255, 0.1)
        .tree-item
          display: flex
          & > a
            flex-grow: 1
          & > button
            width: 40px
            background: transparent
            border: none
            outline: none
            color: white
            font-size: 1rem
            & > i
              font-family: "Font Awesome 5 Free"
              font-weight: 900
              text-decoration: none
              font-style: normal
              &.is-closed:before
                content: "\f078"
              &.is-open:before
                content: "\f077"
      .show-enter-active, .show-leave-active
        transition: opacity 0.3s ease, transform 0.3s ease, max-height 0.3s ease
        transform-origin: left center
        max-height: 500px
        overflow: hidden
      .show-enter, .show-leave-to
        opacity: 0
        max-height: 0
        transform: translateX(-15px)
</style>
